export enum DropdownType {
  tableDropdown = 'tableDropdown',
  fromDropDown = 'fromDropdown',
  toDropdown = ' toDropdown'
}
